(() => {
  const DAYS_DE = [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ];

  const MONTHS_DE = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ];

  function getBerlinNow() {
    return new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" })
    );
  }

  function getDeliveryDate(now, cutoffHour) {
    const day = now.getDay();
    const hour = now.getHours();
    const delivery = new Date(now);

    function addDays(days) {
      delivery.setDate(delivery.getDate() + days);
    }

    if (day === 6 || day === 0) {
      if (hour < cutoffHour) {
        addDays(((2 - day + 7) % 7) || 2);
      } else {
        addDays(((3 - day + 7) % 7) || 3);
      }
    } else if (day === 5) {
      if (hour < cutoffHour) {
        addDays(1);
      } else {
        addDays(4);
      }
    } else {
      if (hour < cutoffHour) {
        addDays(1);
      } else {
        addDays(2);
      }
    }

    return delivery;
  }

  function getCountdown(now, cutoffHour) {
    const cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (now > cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    const diffMs = cutoff - now;
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return { hours, mins };
  }

  function updateTimer(timer) {
    if (!timer) return;

    const cutoffHour = parseInt(timer.dataset.cutoffHour || "13", 10);
    const dateEl = timer.querySelector("[data-delivery-date]");
    const countdownEl = timer.querySelector("[data-countdown]");
    const countryTextEl = timer.querySelector("[data-country-text]");

    if (!dateEl || !countdownEl) return;

    const now = getBerlinNow();
    const delivery = getDeliveryDate(now, cutoffHour);
    const countdown = getCountdown(now, cutoffHour);

    dateEl.textContent = `${DAYS_DE[delivery.getDay()]}, ${delivery.getDate()}. ${MONTHS_DE[delivery.getMonth()]}`;
    countdownEl.textContent = `${countdown.hours} Std. ${countdown.mins} Min.`;

    if (countryTextEl && timer.dataset.countryLabel) {
      countryTextEl.textContent = timer.dataset.countryLabel;
    }
  }

  function updateAllTimers() {
    const timers = document.querySelectorAll("[data-same-day-shipping-timer]");
    timers.forEach(updateTimer);
  }

  function scheduleNextUpdate() {
    updateAllTimers();

    const now = new Date();
    const msToNextMinute =
      (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    setTimeout(scheduleNextUpdate, msToNextMinute);
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateAllTimers();
    scheduleNextUpdate();
  });

  document.addEventListener("shopify:section:load", () => {
    updateAllTimers();
  });

  document.addEventListener("shopify:section:reorder", () => {
    updateAllTimers();
  });
})();